import { type FC } from 'react';
import { type BasicImageTypes, type NextgenImageProps } from './types/propsTypes';

const FallbackNextgenImage: FC<NextgenImageProps> = ({ src, alt, ...rest }: NextgenImageProps) => (
  <img src={src as string} alt={alt} {...(rest as BasicImageTypes)} data-dtrum-mask={rest.isSensitiveField} />
);

export default FallbackNextgenImage;
